import {initDomPolyfills} from "./utils/domPolyfills/index";
import {initApp} from "./app";
import Likely from "ilyabirman-likely";

initDomPolyfills();

initApp();

Likely.initiate();


// const getCssGateaway = (minValue, maxValue, minWidth, maxWidth) => {
// 	const m = (maxValue - minValue) / (maxWidth - minWidth);
// 	const b = minValue - m * minWidth;
// 	return `${m} * 100vw + ${b}px`;
// };
